/**
 *
 * Null-safe some utility, accepting optional predicates
 *
 * @param arr
 * @param filterLambda
 * @returns
 */
export const some = <T>(
  arr: T[] | undefined | null,
  filterLambda: (x: T, idx: number, arr: T[]) => unknown = () => true
): boolean => {
  if (arr == undefined || arr == null) return false;

  if (!Array.isArray(arr)) {
    return false;
  }

  return (arr || []).some(filterLambda);
};
